<div class="contact-modal">
    <div class="consent-container-wrapper">
        <div class="row right">
            <i class="btn-close icon-edponline-Bop-071" *ngIf="data.showClose" data-modal="dismiss()"
            (click)="closeModal()"  aria-hidden="true"></i>
        </div>
        <div class="row">
            <div class="col-12">
                <h1 class="title"> {{ data.title }} </h1>
            </div>
            <div class="col-12">
                <p class="description" [innerHTML]="data.message"></p>
            </div>
        </div>
    </div>
</div>